module.exports = __webpack_public_path__ + "img/unicrypt_v3.060d8029.svg";